// extracted by css-extract-rspack-plugin
export default {"cls1":"AuthorHeader-cls1_7wt","cls2":"AuthorHeader-cls2_rPu AuthorHeader-cls1_7wt"};